module.exports = __webpack_public_path__ + "img/light_footer_bg.ec021867.png";